import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type NewsList = paths['/v4/news/'];

const getNewsList = createRequest<NewsList>('/pc/v4/news/');

export default getNewsList;
